module.exports = __webpack_public_path__ + "static/pizza19-992067837a08d53107221c90604c1651.webp";